import { createActions, createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';

export const { Types, Creators } = createActions({
	// Actions Saga
	alertaBuscar: ['alertaId', 'callback'],
	alertaCadastrar: ['alerta', 'callback'],
	alertaAlterarStatus: ['alerta', 'callback'],
	alertaFiltro: ['filtro', 'callback'],

	// Actions reducers
	alertaBuscarReducer: ['alerta'],
	alertaCadastrarReducer: ['alerta'],
	alertaAlterarStatusReducer: ['alerta'],
	alertaFiltroReducer: ['lista'],
});

export const INITIAL_STATE_VALUES = {
	alerta: {},
	lista: {
		content: [],
		pageable: {
			sort: {
				unsorted: true,
				sorted: false,
			},
			pageSize: 20,
			pageNumber: 0,
			offset: 0,
			unpaged: false,
			paged: true,
		},
		last: true,
		totalPages: 1,
		totalElements: 1,
		numberOfElements: 1,
		first: true,
		sort: {
			unsorted: true,
			sorted: false,
		},
		size: 20,
		number: 0,
	},
};

const INITIAL_STATE = Immutable(Object.assign({}, INITIAL_STATE_VALUES));

const alertaBuscarReducer = (state = INITIAL_STATE, action) => state.merge({
	alerta: { ...action.alerta },
});
const alertaCadastrarReducer = (state = INITIAL_STATE, action) => state.merge({
	alerta: { ...action.alerta },
});
const alertaAlertarStatusReducer = (state = INITIAL_STATE, action) => state.merge({
	alerta: { ...action.alerta },
});
const alertaFiltroReducer = (state = INITIAL_STATE, action) => state.merge({
	lista: { ...action.lista },
});

export default createReducer(INITIAL_STATE, {
	[Types.ALERTA_BUSCAR_REDUCER]: alertaBuscarReducer,
	[Types.ALERTA_CADASTRAR_REDUCER]: alertaCadastrarReducer,
	[Types.ALERTA_ALTERAR_STATUS_REDUCER]: alertaAlertarStatusReducer,
	[Types.ALERTA_FILTRO_REDUCER]: alertaFiltroReducer,
});
